import api from 'shared/api'

export const assignLicenseUsers = (licenseID, companyID, data) => {
  const url = `/api/v1/licenses/${licenseID}/assign_users/?company=${companyID}`
  return api.post(url, data)
}
